import axios from "axios";

export const recurrenceApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/stk-recurrence`,
  headers: {
    "Content-Type": "application/json",
  },
});
